<template>
  <div id="sort-options-panel">
    <span>Sort by&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <sui-button-group icons size="small" id="sort-options">
      <sui-button icon="star" @click="onClickOption('star')"/>
      <sui-button icon="fork" @click="onClickOption('fork')"/>
    </sui-button-group>
  </div>
</template>

<script>
export default {
  methods: {
    onClickOption(option) {
      this.$emit('click', option);
    }
  }
}
</script>

<style>
#sort-options-panel {
  width: 80%;
  margin: 48px auto 0;
}

#sort-options-panel > span {
  font-size: 16px;
  font-weight: bold;
  color: #00ADB5;
}

#sort-options > button {
  /* background-color: rgba(0, 172, 181, 0.5); */
  background-color: rgba(128, 128, 128, 0.1);
  color: rgba(128, 128, 128, 0.6);
}

#sort-options > button:hover, #sort-options > button:focus {
  /* background-color: rgba(0, 172, 181, 0.5); */
  background-color: rgba(128, 128, 128, 0.3);
  color: rgb(255, 191, 0); /*FAD25A*/
}

</style>



// WEBPACK FOOTER //
// src/components/SortOptions.vue